/**
 * ValueProposition - Positioning statement
 *
 * Key differentiator: presets are built around YOUR guitar,
 * not pulled from a generic database.
 */

"use client";

import { useTranslations } from "next-intl";
import { ScrollReveal, ShimmerText } from "./effects";

export default function ValueProposition() {
  const t = useTranslations("landing.valueProposition");

  return (
    <section className="py-16 md:py-20">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <ScrollReveal>
          <div className="text-center space-y-6">
            {/* Main headline */}
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white">
              <ShimmerText>{t("headline")}</ShimmerText>
            </h2>

            {/* Supporting copy */}
            <div className="space-y-3 text-lg md:text-xl text-gray-300 max-w-3xl mx-auto">
              <p>{t("line1")}</p>
              <p>{t("line2")}</p>
            </div>
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
}
